import React from 'react';

import { Button } from 'components/Button';
import { MdClose } from 'react-icons/md';
import { Primary } from 'styles';
import { useAuth } from 'contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import useScript from 'hooks/useScript';
import { STRIPE_KEY, STRIPE_TABLE_ID } from 'config/stripe';

import  './style.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const SubscribePage = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  useScript('https://js.stripe.com/v3/pricing-table.js');

  return (
    <div className='subscribe-container'>
      <div className='cancel-row'>
        <MdClose
          aria-label='cancel-x-button'
          className='close-icon'
          size={32}
          color={Primary.main}
          onClick={() => auth.logout(() => navigate('/'))}
        />
      </div>
      <h2 className='page-header'>Subscribe</h2>
      <div className='stripe-container'>
        <stripe-pricing-table
          pricing-table-id={STRIPE_TABLE_ID}
          publishable-key={STRIPE_KEY}
          client-reference-id={auth.firebaseUser?.uid || '-1'}
        >
        </stripe-pricing-table>
        <p className='subscription-trial-text'>
          Each subscription option comes with a 3 month free trial.<br/>
          You will not be charged until the end of your trial period, and can cancel anytime before.
        </p>
      </div>
      <Button
        accessibilityLabel='logout-button'
        type='primary'
        text='Logout'
        handleOnClick={() => auth.logout(() => navigate('/'))}
      />
    </div>
  );
};
